import type { ThemeConfig } from '@/types/theme'

export function AppearanceCoresLivePreview({ draft }: { draft: ThemeConfig }) {
  return (
    <div className="glass-card p-5">
      <h3 className="text-text-primary font-semibold text-sm mb-4">Preview ao Vivo</h3>
      <div className="flex flex-wrap gap-3 items-center">
        <button
          type="button"
          className="px-4 py-2 rounded-lg text-white text-sm font-medium transition-colors"
          style={{ backgroundColor: draft.brandPrimary }}
        >
          Botão Primário
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded-lg text-white text-sm font-medium"
          style={{ backgroundColor: draft.brandSecondary }}
        >
          Botão Sucesso
        </button>
        <span
          className="px-3 py-1.5 rounded-full text-xs font-medium border"
          style={{
            backgroundColor: draft.brandPrimaryMuted,
            color: draft.brandPrimary,
            borderColor: draft.brandPrimary + '33',
          }}
        >
          Badge
        </span>
        {draft.mode === 'light' && (
          <div
            className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium"
            style={{
              backgroundColor: draft.navActiveMuted,
              color: draft.navActiveColor,
            }}
          >
            Item de menu ativo
          </div>
        )}
        <div className="flex flex-col gap-1 p-3 rounded-xl" style={{ backgroundColor: draft.bgCard }}>
          <span className="font-black text-base" style={{ color: draft.fontColorH1 }}>H1 — Título</span>
          <span className="font-semibold text-sm" style={{ color: draft.fontColorH2 }}>H2 — Subtítulo</span>
          <span className="font-medium text-xs" style={{ color: draft.fontColorH3 }}>H3 — Seção</span>
          <span className="font-medium text-xs" style={{ color: draft.fontColorH4 }}>H4 — Subseção</span>
          <span className="font-medium text-[11px]" style={{ color: draft.fontColorH5 }}>H5 — Tópico</span>
          <span className="font-medium text-[10px]" style={{ color: draft.fontColorH6 }}>H6 — Subtópico</span>
          <span className="text-sm" style={{ color: draft.fontColorBody }}>Body — texto padrão</span>
          <span className="text-xs" style={{ color: draft.fontColorMuted }}>Muted — secundário</span>
          <span className="text-[10px] uppercase tracking-wider font-bold" style={{ color: draft.fontColorLabel }}>
            LABEL
          </span>
        </div>
      </div>
    </div>
  )
}
